export default {
    MD: {
        date: '',
        location: '',
        time: '',
    },
    T: [],
    M: []
}